<template>
  <div class="schedule-container">
    <div v-for="(entries, date, x) in dates" :key="x">
      <ScheduleDate :date="date" :entries="entries" :dayIndex="x" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import ScheduleDate from './ScheduleDate.vue'

export default {
  name: 'Schedule',
  props: ['entries'],
  components: { ScheduleDate },
  computed: {
    dates() {
      return _.groupBy(this.entries, (entry) => {
        return entry.starts_at.slice(0,10)
      })
    }
  }
}
</script>

<style lang="scss">

</style>
